import { jsx } from "react/jsx-runtime";
import { Icon } from "../MainIcon/MainIcon.js";
import "@mui/material";
const DEFAULT_VIEWBOX = "0 0 28 30";
const PhoneIcon = ({ size, viewBox = DEFAULT_VIEWBOX, ...rest }) => {
  return /* @__PURE__ */ jsx(Icon, { size, ...rest, viewBox, children: /* @__PURE__ */ jsx(
    "path",
    {
      d: "M23.3602 18.3555C22.6252 18.338 21.7 18.2948 21.1155 18.1921C20.4832 18.0801 19.7225 17.8631 19.187 17.6963C18.767 17.5656 18.3097 17.6811 17.9982 17.9915L15.4117 20.5628C13.6243 19.6213 12.1928 18.5246 10.9807 17.3055C9.7615 16.0933 8.66483 14.6618 7.72333 12.8745L10.2947 10.2868C10.605 9.97413 10.7205 9.51797 10.5898 9.09797C10.4242 8.56363 10.206 7.8018 10.094 7.16947C9.99133 6.58497 9.94817 5.66097 9.93067 4.9248C9.9155 4.29013 9.3975 3.78613 8.76167 3.78613L4.66667 3.78613C4.15567 3.78613 3.5 4.1688 3.5 4.9528C3.5 10.2483 5.64667 15.3058 9.29367 18.9925C12.9803 22.6395 18.0378 24.7861 23.3333 24.7861C24.1173 24.7861 24.5 24.1305 24.5 23.6195L24.5 19.5245C24.5 18.8886 23.996 18.3706 23.3602 18.3555Z",
      fill: rest.fill
    }
  ) });
};
export {
  PhoneIcon
};
